<template>
  <div>
    <d-checkbox
      toggle
      v-model="enabled"
      class="custom-toggle-sm"
      @change="rebalancePercentages"
    >
      Distribuir palavras por porcentagem
      <i
        id="tooltip-percentage-distribution"
        class="fas fa-info-circle text-muted"
        style="cursor: pointer"
      />
      <d-tooltip :target="'tooltip-percentage-distribution'" placement="top">
        As palavras são distribuídas conforme as porcentagens. Se não houver
        espaço, serão usadas outras direções.
      </d-tooltip>
    </d-checkbox>

    <div v-if="enabled">
      <d-form-row class="d-flex flex-wrap">
        <d-col
          v-for="direction in Object.keys(enabledDirections)"
          :key="direction"
        >
          <label class="form-control-label">
            {{ LABELS_POSITIONS[direction] }}
          </label>
          <d-input-group append="%">
            <d-form-input
              type="number"
              :min="0"
              :max="100"
              placeholder="Número em %"
              v-model.number="localDistribution[direction]"
            />
          </d-input-group>
        </d-col>
      </d-form-row>

      <p class="text-muted mt-2">
        Total: <strong>{{ total }}%</strong>
        <span v-if="total !== 100" class="text-danger">
          (a soma deve ser 100%)</span
        >
      </p>
    </div>
  </div>
</template>

<script>
import { LABELS_POSITIONS } from './HuntingWordsModel';

export default {
  name: 'distribution-by-percentage',
  props: {
    value: {
      type: Object,
      required: true,
    },
    enabledByDefault: {
      type: Boolean,
      default: false,
      required: true,
    },
    enabledDirections: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      LABELS_POSITIONS,
      localDistribution: { ...this.value },
    };
  },
  computed: {
    enabled: {
      get() {
        return this.enabledByDefault;
      },
      set(val) {
        this.$emit('update:enabledByDefault', val);
      },
    },
    total() {
      return Object.values(this.localDistribution).reduce(
        (sum, val) => sum + val,
        0,
      );
    },
  },
  watch: {
    enabledDirections: {
      deep: true,
      handler() {
        if (this.enabled) this.rebalancePercentages();
      },
    },
    localDistribution: {
      deep: true,
      handler(newVal) {
        this.$emit('input', newVal);
        if (this.total === 100) {
          this.$emit('change', newVal);
        }
      },
    },
  },
  methods: {
    rebalancePercentages() {
      const enabledKeys = Object.keys(this.enabledDirections);
      const count = enabledKeys.length;

      if (count === 0) return;

      const base = Math.floor(100 / count);
      const remainder = 100 - base * count;

      const newPercentages = {};

      enabledKeys.forEach((key, index) => {
        newPercentages[key] = base + (index === count - 1 ? remainder : 0);
      });

      this.localDistribution = newPercentages;
    },
  },
};
</script>
